/** Spanish UI strings for "Actualizaciones" (enrollmentUpdates). Code stays in English; copy stays in Spanish. */
import { nombrePropioTexto } from "../../../../utils/textoPropio";

const S = {
	title: "Actualizaciones",
	tabs: { actualizar: "Actualizar", aplicar: "Por Aplicar", flotantes: "Flotantes", historial: "Historial" },
	empty: "Sin pendientes.",
	sinMatriculaVigente: (nombre: string) => nombre ? `${nombrePropioTexto(nombre)}: sin matrícula activa en este plantel.` : "Sin matrícula activa en este plantel.",
	matricularPorSolicitud: "Para que empiece o vuelva a clases, se matricula con una Solicitud de Matrícula.",
	hacerSolicitud: "Hacer Solicitud de Matrícula",
	loading: "Cargando…",
	close: "Cerrar",
	cancel: "Volver",
	choose: "Elegir…",
	// Actualizar
	unaAlumna: "Una Alumna",
	unHorario: "Un Horario",
	searchStudent: "Buscar alumna",
	searchPlaceholder: "Nombre, correlativo o teléfono",
	quienCambia: "Qué Cambia",
	horarioDestino: "Horario Destino",
	cursoDestino: "Curso y Horario Destino",
	cambiar: "Cambiar",
	buscarOtro: "Buscar Otro",
	buscarOtroHorario: "Buscar Otro Horario",
	verSugerencias: "Ver Sugeridos",
	enrollment: "Matrícula",
	schedule: "Horario",
	planLabel: "Plan",
	progressLabel: "Avance",
	paidThrough: "Pagado hasta",
	overdue: "Vencido",
	paidNotCoursed: "Pagado no cursado",
	paid: "Pagado",
	lastSession: "Última sesión que tomó",
	dueDay: "Día de vencimiento",
	dueDayCurrent: (dia: number | null) => dia ? `Hoy vence el ${dia}` : "",
	note: "Nota",
	notePlaceholder: "Nota (obligatoria)",
	missingNote: (nombre: string) => `Falta la nota de ${nombre}`,
	applyNow: "Aplicar Ahora",
	applyN: (n: number) => `Aplicar ${n}`,
	leavePending: "Dejar en Por Aplicar",
	saveDueDay: "Guardar Vencimiento",
	alreadyPending: "Ya tiene una pendiente",
	sent: (n: number) => n === 1 ? "Quedó en Por Aplicar." : `${n} quedaron en Por Aplicar.`,
	applied: "Aplicada.",
	appliedN: (n: number) => n === 1 ? "Aplicada." : `${n} aplicadas.`,
	dueDaySaved: "Vencimiento guardado.",
	sessionsOf: (a: number, b: number) => `${a} de ${b}`,
	sessionsLine: (a: number, b: number, pct: number | null) => `${a} de ${b} sesiones${pct == null ? "" : `, ${Math.round(pct)} % asistencia`}`,
	planLine: (n: number, m: number, dia: number | null) => `Mensualidad ${n} de ${m}${dia ? `, vence el ${dia}` : ""}`,
	goesInSession: (n: number) => `Va en la sesión ${n}`,
	moreSessions: (n: number) => `Repite ${n}`,
	lessSessions: (n: number) => `${n} por reponer`,
	overdueOf: (monto: string) => `Vencido ${monto}`,
	// Reparto
	reparto: "Reparto",
	remainder: "Se queda como Pagado no cursado",
	overAssigned: "Se está repartiendo más de lo que pagó.",
	newPlanTuition: (n: number) => `Mensualidad ${n}, curso nuevo`,
	pendingAmount: (amount: string) => `Pendiente ${amount}`,
	paidNotCoursedLine: (amount: string) => `Pagado que no cursará: ${amount}`,
	// Un horario
	pickSchedule: "Buscar Horario",
	changeMentor: "Cambiar Maestra",
	merge: "Fusionar",
	closeSchedule: "Cerrar Horario",
	closeReason: "Motivo del cierre",
	mergeTarget: "Horario que se queda",
	newMentor: "Maestra Nueva",
	reason: "Motivo",
	students: "Alumnas",
	historyTab: "Historial",
	update: "Actualizar",
	moveStudents: "Mover Alumnas",
	destination: "Destino",
	whatsappVarias: "WhatsApp a Varios",
	selectAll: "Marcar todas",
	byStudent: (n: number) => `${n} ${n === 1 ? "alumna" : "alumnas"}`,
	payOk: "Al Corriente",
	payOverdue: (monto: string) => `Vencida ${monto}`,
	waiting: "Por Aplicar",
	toPlace: (n: number) => `${n} por ubicar`,
	closedOk: "Horario en Cerrando.",
	mergedOk: "Fusión hecha.",
	mentorOk: "Maestra cambiada.",
	col: { student: "Alumna", pay: "Pago", progress: "Avance", attendance: "Asistencia", lastUpdate: "Última Actualización", destination: "Destino", note: "Nota",
		course: "Curso", state: "Estado", why: "Por Qué", days: "Días", date: "Fecha", opening: "Opciones", update: "Actualización", detail: "Detalle",
		requestedBy: "Pidió", appliedBy: "Aplicó", change: "Cambio", money: "Dinero", moneyOk: "Sin movimiento", whatHappens: "Qué Va a Pasar" },
	// Actualizaciones Claras (2026-10-31)
	sinTipo: "Falta elegir qué se hace.",
	motivo: "Motivo",
	pidio: (who: string | null, when: string) => `Pidió ${who || "—"}, ${when}`,
	cierreDe: (horario: string) => `Cierre de Horario de ${horario}`,
	fusionDe: (horario: string) => `Fusión de Horario de ${horario}`,
	pasanA: (destino: string) => `Pasan a ${destino}`,
	confirmTitle: (nombre: string) => `Aplicar a ${nombre}`,
	confirmTitleN: (n: number) => `Aplicar ${n}`,
	confirmApply: "Aplicar",
	confirmBack: "Volver",
	repiteClases: (n: number) => `Repite ${n} ${n === 1 ? "clase" : "clases"}`,
	repartoResumen: (movs: number, resto: string) => movs > 0 ? `Reparto: ${movs} ${movs === 1 ? "movimiento" : "movimientos"}, ${resto} se queda como Pagado no cursado.` : `${resto} se queda como Pagado no cursado.`,
	// Por aplicar
	trays: { pending: "Por Aplicar", returned: "Qué Corregir", mine: "Mías" },
	apply: "Aplicar",
	review: "Revisar",
	open: "Abrir",
	reject: "Rechazar",
	rejectReason: "Motivo",
	rejected: "Rechazada.",
	askFix: "Pedir Corrección",
	fixReason: "Qué corregir",
	fixed: "Quedó en Qué Corregir.",
	resubmit: "Reenviar",
	resubmitComment: "Comentario",
	resubmitted: "Reenviada.",
	onlyCaja: "Solo Caja aplica: mueve dinero.",
	chooseExtra: "Falta elegir qué pasa con las clases que repite.",
	plan: "Plan de pagos",
	progress: (taken: number, total: number) => `Avance, ${taken} de ${total}`,
	requestedByLine: (type: string, who: string | null, when: string | null) => `${type}, pidió ${who || "—"}, ${when || ""}`,
	extraTitle: (n: number) => `Repite ${n} ${n === 1 ? "clase" : "clases"}. Elige:`,
	extraOptions: [
		{ id: 1, t: "Sin cobro extra", d: "Su plan sigue igual." },
		{ id: 2, t: "Agregar mensualidades", d: "Al final, con precio del curso." },
		{ id: 3, t: "Cobrar con descuento", d: "Precio de Caja; pasa a Auditoría." }
	],
	extraMonths: "Mensualidades",
	extraPrice: "Precio",
	filterType: "Tipo",
	filterRequester: "Pidió",
	filterSchedule: "Horario",
	of: "De",
	to: "A",
	// Flotantes
	flotantes: "Flotantes",
	porCerrar: "Por Cerrar",
	whatHappened: "Qué Pasó",
	campusFilter: "Plantel",
	courseFilter: "Curso",
	originFilter: "Venía De",
	datesFilter: "Fechas",
	daysFilter: "Días",
	owesFilter: "Pago",
	contactFilter: "Contacto",
	owes: "Debe",
	upToDate: "Al Corriente",
	contacted: "Contactada",
	notContacted: "Sin Contactar",
	locate: "Ubicar",
	whatsapp: "WhatsApp",
	noneOpen: "Ninguno abierto",
	from: "Desde",
	until: "Hasta",
	moreThan: (n: number) => `Más de ${n}`,
	cupo: (n: number) => `${n}`,
	reentry: "Ubicar",
	projection: "Proyección",
	sessionsPending: (n: number) => `${n} sesiones pendientes`,
	whatsappText: "Mensaje",
	balanceOf: (monto: string) => `Saldo ${monto}`,
	pendingTuitions: (n: number) => `${n} ${n === 1 ? "mensualidad pendiente" : "mensualidades pendientes"}`,
	byCampus: (nombre: string, n: number) => `${nombre} ${n}`,
	sessionsTakenOf: (a: number, b: number) => `${a} de ${b}`,
	system: "Sistema",
	requestedByShort: (n: string) => `Pidió ${n}`,
	removeFilters: "Quitar Filtros",
	prev: "Anterior",
	next: "Siguiente",
	flot: { student: "Alumna", course: "Curso y Módulo", what: "Qué Pasó", dateDays: "Fecha y Días", who: "Quién", pay: "Pago", contacted: "Contactada", opening: "Opciones", sessions: "Sesiones", endDate: "Fin del Horario" },
	// Historial
	presets: { hoy: "Hoy", semana: "Esta Semana", mes: "Este Mes", todo: "Todo" },
	statusFilter: "Estado",
	appliedByFilter: "Aplicó",
	searchLog: "Alumna, horario, nota",
	statusLabels: { 0: "Borrador", 1: "Por Aplicar", 2: "Qué Corregir", 3: "Aplicada", 4: "Rechazada" } as { [k: number]: string },
	seeReason: "Ver Motivo",
	undoReparto: "Deshacer Reparto",
	undoRepartoReason: "Motivo",
	undoRepartoDone: (monto: string) => `Reparto deshecho, ${monto} regresaron a sus mensualidades.`,
	rejection: "Rechazo",
	// Confirmar antes de Aplicar Ahora (Una Alumna, Un Horario), 2026-10-31
	pasaA: (destino: string) => `Pasa a ${destino}`,
	regresaA: (destino: string) => `Regresa a ${destino}`,
	repiteClasesMin: (n: number) => `repite ${n} ${n === 1 ? "clase" : "clases"}`,
	faltanClases: (n: number) => n === 1 ? "Le falta 1 clase, queda por reponer" : `Le faltan ${n} clases, quedan por reponer`,
	debeVencidos: (monto: string) => `Debe ${monto} vencidos`,
	mismosMeses: "Sus mensualidades se quedan en los mismos meses; solo cambia el día de pago.",
	quedaEstado: (estado: string) => `Matrícula queda ${estado}.`,
	// Restyle like Matrículas (2026-11-01)
	enviarAprobacion: "Enviar a Aprobación",
	repiteRevisaCaja: (n: number) => `Repite ${n} ${n === 1 ? "clase" : "clases"}: lo revisa Caja.`,
	repiteDesdePorAplicar: (n: number) => `Repite ${n} ${n === 1 ? "clase" : "clases"}: se aplica desde Por Aplicar.`,
	estadoQueda: { 4: "Aplazada", 5: "Sin Horario", 7: "Retirada", 8: "No Comenzada", 9: "en Error", 10: "Graduada", 11: "Pausada" } as { [typeId: number]: string }
};

export default S;
